import {type GetterTree} from 'vuex';

const getters: GetterTree<ModuleInstallerState, RootState> = {
    versionSelectOptions(state)
    {
        const options: SelectOption[] = [];

        for (let index in state.versions)
        {
            if (!state.versions.hasOwnProperty(index) || !state.versions[index])
            {
                continue;
            }

            options.push({
                label: state.versions[index],
                value: state.versions[index],
            })
        }

        return options;
    },
};

export default getters;